import { MaterialUICore } from '@iclinic/design-system';
import React from 'react';

import { tabsTitle, tabsValue } from 'features/video-conference/constants';
import { useAnnotationContext } from 'features/video-conference/state/annotationContext';

const { Tabs: UiTabs, Tab } = MaterialUICore;

export default function Tabs() {
  const { activeTab, setActiveTab } = useAnnotationContext();

  const handleChangeTab = (_event: React.ChangeEvent<{}>, value: string) => {
    setActiveTab(value);
  };

  return (
    <UiTabs
      value={activeTab}
      textColor="primary"
      indicatorColor="primary"
      onChange={handleChangeTab}
    >
      <Tab label={tabsTitle.CLINIC_NOTE} value={tabsValue.CLINIC_NOTE} />
      <Tab label={tabsTitle.PATIENT_NOTE} value={tabsValue.PATIENT_NOTE} />
    </UiTabs>
  );
}
